import { useMutation, type UseMutationResult } from "@tanstack/react-query";

import { API_ROUTES } from "../../api/ApiRoutes";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import type { CasinoBet, SearchUserCasinoBetParams } from "../../types/bets";

type StoredToken = { AccessToken?: string };

const DEFAULT_CASINO_BET_TYPE = "6";

const fetchCasinoBetById = async (
  params: SearchUserCasinoBetParams,
): Promise<CasinoBet | undefined> => {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString ? JSON.parse(tokenString) : null;
  const instance = createPrivateAdminPanelInstance(token?.AccessToken);

  const betType = params.bet_type ?? DEFAULT_CASINO_BET_TYPE;
  const url = API_ROUTES.GET_BET_BY_ID.replace("{user_id}", encodeURIComponent(params.user_id))
    .replace("{bet_id}", encodeURIComponent(params.bet_id))
    .replace("{bet_type}", String(betType));

  const response = await instance.get(url);

  const body = response?.data?.data;
  return body as CasinoBet | undefined;
};

export const useSearchUserCasinoBet = (): UseMutationResult<
  CasinoBet | undefined,
  Error,
  SearchUserCasinoBetParams
> => {
  return useMutation<CasinoBet | undefined, Error, SearchUserCasinoBetParams>({
    mutationFn: fetchCasinoBetById,
  });
};
